import { Box, HStack, Header, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const ButtonsContainer = Box.withConfig({
  marginTop: '$6',
  maxWidth: '300px',
});

export const HeaderStyled = Header.withConfig({
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
  color: theme.token('text-hero-light'),
  variant: 'hero',
  lineHeight: 'xs',
  fontWeight: 700,
  marginBottom: '$0',
  fontSize: {
    base: '4xl',
    md: '5xl',
    lg: '6xl',
  },
});

export const HeroSection = HStack.withConfig({
  background: 'transparent',
});

export const DisclaimerText = Text.withConfig({
  fontSize: '9px',
  marginBottom: '$2',
  alignSelf: 'flex-start',
});
